import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface NotePreview {
    _id: string;
    user: string;
    userId: string;
    note: string;
    timestamp: string;
}

interface OrderNotesResponse {
    notes: NotePreview[];
}

const getOrderNotesPreview = async (sessionId: string, orderId: string): Promise<NotePreview[]> => {
    const { data } = await axios.post<OrderNotesResponse>(`${API_URL}/order/notes`,
        { orderId },
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data.notes;
};

export const useGetOrderNotesPreview = (orderId: string, enabled: boolean) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['order-notes-preview', orderId],
        queryFn: () => getOrderNotesPreview(sessionContext?.sessionId ?? '', orderId),
        enabled: enabled && !!sessionContext?.sessionId && !!orderId,
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
    });
};
